import { render, staticRenderFns } from "./projectBoard.vue?vue&type=template&id=4c5280cc&scoped=true"
import script from "./projectBoard.vue?vue&type=script&lang=js"
export * from "./projectBoard.vue?vue&type=script&lang=js"
import style0 from "./projectBoard.vue?vue&type=style&index=0&id=4c5280cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5280cc",
  null
  
)

export default component.exports